export const routes = {
    rootAny: "*",
    root: "/",
    neurodoc: "/neurodoc",
    wordAddin: "/word-addin",
    oldTemplates: "/admin/:templateId",
    myTemplates: "/my-templates",
    template: "/my-templates/:templateId",
    oldDocuments: "/:templateId",
    documents: "/documents",
    document: "/documents/:templateId",
    iframe: "/iframe/:templateId",
    externalForm: "/:extUserId/:templateId"
};
